module.exports = __webpack_public_path__ + "img/CCL.029e8916.png";